import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@medflex/components/stories/Button';
import FeatureUpgradeModal from '@medflex/components/stories/FeatureUpgradeModal';
import { trackEvent, TRACKING_ACTIONS } from '@medflex/utils/Tracking';
import { FEATURE_KEYS } from '@medflex/utils/subscriptionEnums';
import createUpgradeUrl from '@medflex/utils/createUpgradeUrl';
import { UPGRADE_SUBSCRIPTION_PACKAGE_URL } from '../../constants';
import { MODALS } from '../../hooks/useIsModal';
import useModal from '../../hooks/useModal';
import useSubscription from '../../hooks/useSubscription';

const FeatureUpgradePhysicianStatus = () => {
  const { close } = useModal();
  const { t } = useTranslation('physician');
  const translate = (key, ...props) =>
    t(`FeatureUpgradeModules.FeatureUpgradePhysicianStatus.${key}`, ...props);
  const { email: subscriptionEmail, plan: subscriptionPlan } = useSubscription();

  const handleClose = event => {
    trackEvent(event, {
      action: TRACKING_ACTIONS.CLOSE,
      actionText: 'FeatureUpgradePhysicianStatus',
    });
    close({ modal: MODALS.featureUpgradePhysicianStatus });
  };

  const handleOpenUpgradeSubscription = event => {
    trackEvent(event, {
      action: 'upgrade anfragen',
      actionText: 'FeatureUpgradePhysicianStatus',
    });

    const upgradeSubscriptionUrl = createUpgradeUrl({
      baseUrl: UPGRADE_SUBSCRIPTION_PACKAGE_URL,
      feature: FEATURE_KEYS.PHYSICIAN_STATUS,
      plan: subscriptionPlan.toLowerCase(),
      email: subscriptionEmail,
    });
    window.open(upgradeSubscriptionUrl, '_blank');
  };

  return (
    <FeatureUpgradeModal onClose={handleClose} title={translate('title')}>
      <div data-component="FeatureToggle__FeatureUpgradePhysicianStatus" className="flex flex-col">
        <p className="mb-6">{translate('description', { allowHtml: true })}</p>

        <div>
          <Button onClick={handleOpenUpgradeSubscription}>{translate('upgrade.cta')}</Button>
        </div>
      </div>
    </FeatureUpgradeModal>
  );
};

export default FeatureUpgradePhysicianStatus;
